const baseUrl = "/insights-hub";

export default {
  baseUrl,
  HUB: `${baseUrl}/hub`,
  CATEGORIES: `${baseUrl}/categories`,
};
